import { WidgetManager } from '../../Manager/WidgetManager';
var StaticPane = /** @class */ (function () {
    function StaticPane() {
        this.widgetManager = new WidgetManager();
    }
    StaticPane.prototype.show = function (params, element, showCb) {
        this.widgetManager.show(params, element, showCb);
    };
    StaticPane.prototype.hide = function (params) {
        this.widgetManager.hide(params);
    };
    StaticPane.prototype.destroy = function (params) {
        this.widgetManager.destroy(params);
    };
    return StaticPane;
}());
export { StaticPane };
